import { createSelector } from '@opengov/compose-app/reselect';
import { selectFeatureFlags } from '@opengov/feature-flag/selectors';

import { getEntity, getRequestedEntity } from '../entity/selectors';
import { getSession, getSessionEntityId } from '../session/selectors';

export const getUserIdentifier = createSelector(
  getSession,
  session => session.get('uuid', null)
);

export const getEntityIdentifier = createSelector(
  getEntity,
  getRequestedEntity,
  (entity, requestedEntity) =>
    // If user is OG we want to use the requested entity for identification
    requestedEntity ? requestedEntity.get('salesforce_id', 'test') : entity.get('salesforce_id', 'test')
);

export const getLaunchDarklyFlags = createSelector(
  selectFeatureFlags,
  featureFlags => {
    const flags = featureFlags.toJS();
    const flagKeys = Object.keys(flags);
    return flagKeys.filter(flagName => flags[flagName] === true);
  }
);

export const getUserProperties = createSelector(
  getSession,
  getLaunchDarklyFlags,
  (session, flags) => {
    const url = window.location.pathname;
    const suite = url.indexOf('strategic-initiatves') > -1 ? 'bp' : 'rt';
    const email = session.email ? session.email : '';
    const isEmailOpengov =
      email
        .split('@')
        .slice(-1)
        .toString() === 'opengov.com';

    return {
      user_id: session.id,
      user_entity_id: session.entity.entity_id,
      user_roles: session.role ? [session.role.name] : [],
      user_title: session.title,
      user_is_opengov_employee: isEmailOpengov,
      user_suite: suite,
      user_department: session.department,
      email: email,
      created_at: session.created_at,
      user_entity_salesforce_id: session.entity.salesforce_id,
      user_launchdarkly_features: flags,
      user_delphius_features: session.entity.feature_permissions,
      internal_external: isEmailOpengov, // To be deprecated
      user_hash: session.user_intercom_hash, // To be deprecated
      user_role: session.role ? session.role.name : null, // To be deprecated
      entity_id: session.entity.entity_id // To be deprecated
    };
  }
);

export const getEntityProperties = createSelector(
  getEntity,
  entity => {
    const type = entity.entity_type
      ? typeof entity.entity_type === 'string'
        ? entity.entity_type
        : entity.entity_type.name
        ? entity.entity_type.name
        : null
      : null;

    return {
      entity_bp_id: entity.entity_id,
      entity_rt_id: entity.entity_id,
      name: entity.name,
      created_at: entity.created_at,
      entity_salesforce_id: entity.salesforce_id,
      entity_type: type,
      entity_country: entity.country,
      entity_state: entity.state
    };
  }
);

export const isReady = createSelector(
  getSessionEntityId,
  entityId => {
    return entityId !== null;
  }
);

export const makeFriendlyActionType = rawEventName => {
  // "viewed_route" becomes: "Viewed route"
  //
  // @opengov/report/2.0.8/report-configuration/setVisualizationQueryShowColumnName
  // becomes:
  // Report: Report configuration: SetVisualizationQueryColumnName
  const cleanEventName = rawEventName
    .replace(/_/g, ' ')
    .replace(/-/g, ' ')
    .split('/')
    .pop();
  let packageName = rawEventName.split('/')[1];
  packageName = packageName
    ? `${packageName.charAt(0).toUpperCase()}${packageName
        .slice(1)
        .replace(/_/g, ' ')
        .replace(/-/g, ' ')}: `
    : '';
  let actionGroup = rawEventName.split('/')[3];
  actionGroup = actionGroup
    ? `${actionGroup.charAt(0).toUpperCase()}${actionGroup
        .slice(1)
        .replace(/_/g, ' ')
        .replace(/-/g, ' ')}: `
    : '';
  
  return `${packageName}${actionGroup}${cleanEventName.charAt(0).toUpperCase()}${cleanEventName.slice(1)}`;
};
